import { Directive } from "@angular/core";

/**
 * This Tag should be sole child of the mat-dialog-content tag in a dialog
 * Its used to fix the undesired appearance of scroll bars in certain cases inside the dialog.
 * This tag should be used in the following way:
 *
 * <mat-dialog-content>
 *   <mgd-dialog-content-container>
 *      Dialog content goes here
 *   </mgd-dialog-content-container>
 * </mat-dialog-content>
 */
@Directive({
    selector: "mgd-dialog-content-container",
    host: {
        class: "mgd-dialog-content-container"
    }
})
export class DialogContentContainerDirective {}
